export const painPoints: string[] = [
  'Tenés apuntes y referencias repartidos en distintos materiales.',
  'Te cuesta encontrar una secuencia para repasar conceptos fundamentales.',
  'Estudiás cada rama por separado y querés observar mejor sus conexiones.',
  'Querés ampliar tus conocimientos más allá de una sola técnica.',
  'Buscás materiales visuales para acompañar tu estudio y tu práctica.',
]
